import React from "react";

export const ChevronLeftCircleIcon = ({}) => {
  return (
    <>
        <path d="M12,24 C18.6281247,24 24,18.6281247 24,12 C24,5.37187529 18.6281247,0 12,0 C5.37187529,0 0,5.37187529 0,12 C0,18.6281247 5.37187529,24 12,24 Z M12.4382815,18.3117185 L7.18828154,13.0617185 C6.89531279,12.7687497 6.75,12.3843756 6.75,12 C6.75,11.6156244 6.89648438,11.2321873 7.18945312,10.9396877 L12.4394531,5.68968773 C13.0253906,5.10375023 13.9746094,5.10375023 14.5605469,5.68968773 C15.1464844,6.27562523 15.1464844,7.22484398 14.5605469,7.81078148 L10.3734376,12 L14.5593753,16.1906247 C15.1453128,16.7765622 15.1453128,17.725781 14.5593753,18.3117185 C13.9734378,18.897656 13.024219,18.897656 12.4382815,18.3117185 Z"></path>
    </>
  );
};
